import React from 'react';
import Header from 'pages/Employees/Header';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PinField from 'pages/Employees/Pin/PinField';
import styles from './AdministratorList.css';

class AdministratorList extends React.Component {
  render() {
    const outlets = this.props.outletsEmployees.sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    return (
      <div className={styles.wrapper}>
        <Header title="LIST OF ADMINISTRATOR" />
        <div className={styles.description}>
          All outlets are recommended to have at least 1 employee with
          administrator role and PIN assigned. To assign employee, go to{' '}
          <Link to="/employees/staff">Employee Slot</Link>
        </div>

        <div className={`row ${styles['space-30px']} ${styles['mb-10px']}`}>
          <div className={`col-md-12`}>
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th>{`Outlet`}</th>
                  <th>{`Employee Name`}</th>
                  <th>{`PIN`}</th>
                </tr>
              </thead>
            </table>
            <div className={styles['table-content-wrapper']}>
              <table className={styles['table-content']}>
                <tbody>
                  {outlets.length > 0 &&
                    outlets.map((outlet, index) => {
                      return this._validOutletEmployees(outlet.employees) ? (
                        outlet.employees.map((employee, index) => {
                          if (this._checkIsAdmin(employee.role_level)) {
                            return (
                              <tr key={index}>
                                <td>{outlet.name}</td>
                                <td>{employee.name}</td>
                                <td>
                                  {employee.pin ? (
                                    <PinField pin={employee.pin} />
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        })
                      ) : (
                        <tr key={index}>
                          <td>{outlet.name}</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _checkIsAdmin = roleLevel => {
    return roleLevel === 2;
  };

  _validOutletEmployees = outletEmployees => {
    return outletEmployees.length > 0 && this._hasAdmin(outletEmployees);
  };

  _hasAdmin = outletEmployees => {
    const filteredOutlets = outletEmployees.filter(
      outletEmployee => outletEmployee.role_level === 2
    );
    return filteredOutlets.length > 0;
  };
}

AdministratorList.propTypes = {
  outletsEmployees: PropTypes.array,
};

export default AdministratorList;
